import languageCodes from '../consts/localization/languageCodes';
import {CS} from './localization/defaultLocalizationDictionaries/CS';
import {EN} from './localization/defaultLocalizationDictionaries/EN';

const isIOSStandalone = () =>
    window.matchMedia?.('(display-mode: standalone)').matches ||
    (typeof navigator !== 'undefined' && navigator.standalone === true);

const downloadFile = (blob, fileName) => {
    try {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        const revoke = () => URL.revokeObjectURL(url);

        if (isIOSStandalone()) {
            const t1 = setTimeout(revoke, 15000);
            const onVisible = () => {
                if (document.visibilityState === 'visible') {
                    clearTimeout(t1);
                    revoke();
                    document.removeEventListener('visibilitychange', onVisible);
                }
            };

            document.addEventListener('visibilitychange', onVisible);
        } else {
            setTimeout(revoke, 1000);
        }

        console.log('File downloaded');
    } catch (e) {
        console.error('Error downloading file:', e);
    }
};

const getFileData = async ({content, fileName, fileType}) => {
    const blob = new Blob([content], {type: fileType});
    const file = new File([blob], fileName, {type: fileType});

    return {blob, file};
};

const getDefaultLocalizationDataFromCode = (languageCode) => {
    switch (languageCode) {
        case languageCodes.EN:
            return {name: 'EN', dictionary: EN};
        case languageCodes.CS:
            return {name: 'CS', dictionary: CS};
        default:
            return {name: 'EN', dictionary: EN};
    }
};

const downloadDefaultLocalization = async (marketCode) => {
    const localizationData = getDefaultLocalizationDataFromCode(marketCode);

    if (localizationData.dictionary?.undefined !== '') {
        localizationData.dictionary.undefined = '';
    }

    const dataStr = JSON.stringify(localizationData?.dictionary, null, 2);

    const fileData = await getFileData({
        content: dataStr,
        fileName: `${localizationData?.name}.json`,
        fileType: 'application/json',
    });

    downloadFile(fileData.blob, fileData.file.name);
};

const downloadAndShareLogs = async (logs) => {
    const fileContent = logs.join('\n');

    const now = new Date();
    const timestamp = now.toISOString().slice(0, 19).replace(/[:T]/g, '-');

    const fileData = await getFileData({
        content: fileContent,
        fileName: `logs_${timestamp}.txt`,
        fileType: 'text/plain',
    });

    downloadFile(fileData.blob, fileData.file.name);
};

export default {
    downloadDefaultLocalization,
    downloadAndShareLogs,
};
